window.LeAllVideos = {
    EN: {
        "QzIt5Ib_7Kc": {
            title: 'How to Set Up Lepro AI Smart Lights',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_BulbsT1_EN_how.jpg?v=1752047988',
            products: ['Bulbs']
        },
        "vzzF_8vl1Ao": {
            title: 'How to Assemble & Connect ZB1 Smart String Lights',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_ZB1_EN_how.jpg?v=1751940305',
            products: ['ZB1']
        },
        "hwE_MeHwIks": {
            title: 'How to Install & Connect WL1 Wall Light',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_WL1_EN_how.jpg?v=1751940305',
            products: ['WL1']
        },
        "phqcGg8C7ic": {
            title: 'How to Assemble & Connect TB2 Smart Lamp',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_TB2_EN_how.jpg?v=1751940305',
            products: ['TB2']
        },
        "MutOVDKbxsQ": {
            title: 'How to Assemble & Connect TB1 Smart Lamp',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_TB1_EN_how.jpg?v=1751940305',
            products: ['TB1']
        },
        "vQ8Nf2nZmuc": {
            title: 'How to Install & Connect T1 Smart Ceiling Light',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_T1_EN_how.jpg?v=1751940305',
            products: ['T1']
        },
        "GY8lxnULkeM": {
            title: 'How to Install & Connect S1 Strip Light',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_S1_EN_how.jpg?v=1751940305',
            products: ['S1']
        },
        "leIcGmtTWIY": {
            title: 'How to Install & Connect R2 Downlights',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_R2_EN_how.jpg?v=1751940305',
            products: ['R2']
        },
        "QItCzc7C5o4": {
            title: 'Lepro P1 Smart Plug Mini',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_P1_EN_how.jpg?v=1751940305',
            products: ['P1']
        },
        "uox4a267FVE": {
            title: 'How to Assemble & Connect O1 Smart Floor Lamp',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_O1_EN_how.jpg?v=1751940305',
            products: ['O1']
        },
        "Qve034XqKEc": {
            title: 'How to Install & Connect N1 Neon Rope Light',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_N1_EN_how.jpg?v=1751940305',
            products: ['N1']
        },
        "NHakcryq1qs": {
            title: 'How to Assemble & Connect E1 AI Smart Permanent Outdoor Lights',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_E1_EN_how.jpg?v=1751940305',
            products: ['E1']
        },
        "M8JrYo11VUc": {
            title: 'How to Install & Connect M1 Indoor/Outdoor Spot Camera',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_M1_EN_how_jpg.jpg?v=1759134680',
            products: ['M1']
        },
        "kzFxnP5dqnM": {
            title: 'How to Install & Connect D1 Indoor Pan Tilt AI Camera',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/D1-cover.jpg?v=1787730463',
            products: ['D1']
        },
        "sIaTpTh-6p0": {
            title: 'How to Connect F1/F2 Smart Flood Light',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_F1_EN_how.jpg?v=1759214427',
            products: ['F1/F2']
        },
        "NsAQTBmph60": {
            title: 'How to Assemble Lepro OE1 Floor Lamp',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_OE1_EN_how_to_install.jpg?v=1759215145',
            products: ['OE1']
        },
        "07bVgoQdNCs": {
            title: 'How to Connect Lepro OE1 Floor Lamp',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_OE1_EN_how_to_connect.jpg?v=1759215145',
            products: ['OE1']
        },
        "fYCvnlYAO-w": {
            title: 'Steps to Enable Voice Control - Amazon Alexa',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Alexa_EN_how.jpg?v=1752047735',
            products: []
        }
    },
    DE: {
        "-13UO8OUOXg": {
            title: 'So richten Sie das intelligente Licht Lepro AI ein',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_BulbsT1_DE_how.jpg?v=1752047974',
            products: ['Bulbs']
        },
        "rT0-O1mch8k": {
            title: 'Zusammenbau und Anschluss der ZB1 Smart LED Lichterkette Außen',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_ZB1_DE_how.jpg?v=1751940305',
            products: ['ZB1']
        },
        "OGpDnREfbYc": {
            title: 'Montage und Anschluss der WL1 Glide Wall Light',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_WL1_DE_how.jpg?v=1751940305',
            products: ['WL1']
        },
        "3E-OSGpuXwM": {
            title: 'Zusammenbau und Anschluss der Smart Tischlampe TB2',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_TB2_DE_how.jpg?v=1751940305',
            products: ['TB2']
        },
        "Eqm9coEaSdg": {
            title: 'Zusammenbau und Anschluss der Smart Tischlampe TB1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_TB1_DE_how.jpg?v=1751940305',
            products: ['TB1']
        },
        "jfXzP6FsLeY": {
            title: 'Montage und Anschluss der Smart Deckenlampe T1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_T1_DE_how.jpg?v=1751940305',
            products: ['T1']
        },
        "ucQ3YqgtiGg": {
            title: 'Installation und Anschluss des S1 LED-Streifen',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_S1_DE_how.jpg?v=1751940305',
            products: ['S1']
        },
        "dYfWRu6I6QI": {
            title: 'Zusammenbau und Anschluss der Smart Stehlampe O1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_O1_DE_how.jpg?v=1751940305',
            products: ['O1']
        },
        "4zQHqKs2d9w": {
            title: 'Installation und Anschluss des N1 Neon LED Strip',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_N1_DE_how.jpg?v=1751940305',
            products: ['N1']
        },
        "JlsyMCxvpYM": {
            title: 'Schritte zum Aktivieren der Sprachsteuerung - Amazon Alexa',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Alexa_DE_how.jpg?v=1752047746',
            products: []
        }
    },
    FR: {
        "v8QR1B_RK24": {
            title: 'Comment Configurer les Lumières Intelligentes Lepro AI',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_BulbsT1_FR_how.jpg?v=1752047980',
            products: ['Bulbs']
        },
        "xjAusd5oUA0": {
            title: 'Comment Assembler et Connecter les Guirlandes Lumineuses Intelligentes ZB1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_ZB1_FR_how.jpg?v=1751940305',
            products: ['ZB1']
        },
        "0OpMvmjr2Lc": {
            title: 'Comment Installer & Connecter WL1 Wall Light',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_WL1_FR_how.jpg?v=1751940305',
            products: ['WL1']
        },
        "9es7zvfXHj4": {
            title: 'Comment Assembler & Connecter la Lampe Intelligente TB2',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_TB2_FR_how.jpg?v=1751940305',
            products: ['TB2']
        },
        "rC2PJED7GB8": {
            title: 'Comment Assembler & Connecter la Lampe Intelligente TB1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_TB1_FR_how.jpg?v=1751940305',
            products: ['TB1']
        },
        "xe52I-_4DWU": {
            title: 'Comment Installer et Connecter le Plafonnier Intelligent T1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_T1_FR_how.jpg?v=1751940305',
            products: ['T1']
        },
        "lX-9NPy1vyc": {
            title: 'Comment installer et connecter S1 Ruban LED',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_S1_FR_how.jpg?v=1751940305',
            products: ['S1']
        },
        "H3FSPLu6hCY": {
            title: 'Comment Asembler & Connecter le Lampadaire intelligent O1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_O1_FR_how.jpg?v=1751940305',
            products: ['O1']
        },
        "7kx8GEiFMTM": {
            title: 'Comment Installer & Connecter N1 Neon Ruban LED',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_N1_FR_how.jpg?v=1751940305',
            products: ['N1']
        },
        "UPKdOHfwkrM": {
            title: 'Comment Assembler & Connecter E1 IA Éclairage Extérieur Permanent',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_E1_FR_how.jpg?v=1751940305',
            products: ['E1']
        },
        "weaVbPigx3M": {
            title: 'Étapes Pour Activer la Commande Vocale – Amazon Alexa',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Alexa_FR_how.jpg?v=1752047771',
            products: []
        }
    },
    ES: {
        "pI_2Bhq97h4": {
            title: 'Cómo Configurar las Luces Inteligentes Lepro AI',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_BulbsT1_ES_how.jpg?v=1752047969',
            products: ['Bulbs']
        },
        "Ot_fJawv9To": {
            title: 'Cómo Montar & Conectar las Luces de Cadena Inteligentes ZB1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_ZB1_ES_how.jpg?v=1751940305',
            products: ['ZB1']
        },
        "HxThZC4Vx4Y": {
            title: 'Cómo Instalar & Conectar las Luces de Pared WL1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_WL1_ES_how.jpg?v=1751940305',
            products: ['WL1']
        },
        "rTtVNo-EUPE": {
            title: 'Cómo Montar & Conectar la Lámpara Inteligente TB2',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_TB2_ES_how.jpg?v=1751940305',
            products: ['TB2']
        },
        "UcR0WNBGWGo": {
            title: 'Cómo Montar & Conectar la Lámpara Inteligente TB1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_TB1_ES_how.jpg?v=1751940305',
            products: ['TB1']
        },
        "FD7hVFiqfjo": {
            title: 'Cómo Instalar & Conectar la Plafón de Techo Inteligente T1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_T1_ES_how.jpg?v=1751940305',
            products: ['T1']
        },
        "wZWgNYJ_xVw": {
            title: 'Cómo Instalar & Conectar la Tira LED Inteligente S1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_S1_ES_how.jpg?v=1751940305',
            products: ['S1']
        },
        "eZe3XcvHoZA": {
            title: 'Cómo Montar & Conectar la Lámpara de Pie Inteligente O1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_O1_ES_how.jpg?v=1751940305',
            products: ['O1']
        },
        "JIIkfLyLRUo": {
            title: 'Cómo Instalar & Conectar la Tira LED Neon N1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_N1_ES_how.jpg?v=1751940305',
            products: ['N1']
        },
        "aXbi69CgpYs": {
            title: 'Cómo Montar & Conectar la Luces Exteriores Permanentes AI E1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_E1_ES_how.jpg?v=1751940305',
            products: ['E1']
        },
        "ri1JrghucBw": {
            title: 'Pasos para Habilitar el Control por Voz - Amazon Alexa',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Alexa_ES_how.jpg?v=1752047758',
            products: []
        }
    },
    IT: {
        "R964tLS846c": {
            title: 'Come Configurare le Luci Smart Lepro AI',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_BulbsT1_IT_how.jpg?v=1752047998',
            products: ['Bulbs']
        },
        "UgwR3Srm1To": {
            title: 'Come Installare e Collegare la Catena Luminosa Esterno Smart ZB1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_ZB1_IT_how.jpg?v=1751940305',
            products: ['ZB1']
        },
        "HIxiu6IfbV0": {
            title: 'Come Installare e Collegare la Smart Multicolor Wall Light WL1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_WL1_IT_how.jpg?v=1751940305',
            products: ['WL1']
        },
        "lqVB0THW6rE": {
            title: 'Come Assemblare e Collegare la Lampada Intelligente TB2',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_TB2_IT_how.jpg?v=1751940305',
            products: ['TB2']
        },
        "HxS3GQA1voE": {
            title: 'Come Assemblare e Collegare la Lampada Intelligente TB1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_TB1_IT_how.jpg?v=1751940305',
            products: ['TB1']
        },
        "0OjCfkm4ddg": {
            title: 'Come Installare e Collegare la Plafoniera Intelligente T1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_T1_IT_how.jpg?v=1751940305',
            products: ['T1']
        },
        "pH16-Uq2zPk": {
            title: 'Come Installare e Collegare la Smart Striscia LED S1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_S1_IT_how.jpg?v=1751940305',
            products: ['S1']
        },
        "suba2o-z6E0": {
            title: 'Come Installare e Collegare la Smart Lampada da Terra O1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_O1_IT_how.jpg?v=1751940305',
            products: ['O1']
        },
        "l7W2gxC68qw": {
            title: 'Come Installare e Collegare la Smart Neon Strisica LED N1',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_N1_IT_how.jpg?v=1751940305',
            products: ['N1']
        },
        "87E58XWdHNg": {
            title: 'Come Installare e Collegare le Luci Esterne Permanenti Smart E1 AI',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_E1_IT_how.jpg?v=1751940305',
            products: ['E1']
        },
        "Z-53or2yopE": {
            title: 'Passaggi per Abilitare il Controllo Vocale - Amazon Alexa',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Alexa_IT_how.jpg?v=1752047766',
            products: []
        }
    },
    JP: {
        "D_yR2kCg96M": {
            title: 'Lepro AIスマートライトの設定方法',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Bulbs_JP_how.jpg?v=1752048011',
            products: ['Bulbs']
        },
        "7MG0KbHcg5g": {
            title: 'ZB1 ストリングライトの組み立てと接続方法',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_ZB1_JP_how.jpg?v=1751940305',
            products: ['ZB1']
        },
        "_tqHl5GEpPk": {
            title: 'WL1 ウォールライトの取り付けと接続方法',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_WL1_JP_how.jpg?v=1751940305',
            products: ['WL1']
        },
        "I4ojQcMz-nA": {
            title: 'TB2 スマートランプの組み立てと接続方法',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_TB2_JP_how.jpg?v=1751940305',
            products: ['TB2']
        },
        "7Sq1ViFBbLo": {
            title: 'TB1 スマートランプの組み立てと接続方法',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_TB1_JP_how.jpg?v=1751940305',
            products: ['TB1']
        },
        "RVQ1wpgl3Nc": {
            title: 'S1 テープライトの取り付けと接続方法',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_S1_JP_how.jpg?v=1751940305',
            products: ['S1']
        },
        "34gplGIIBu8": {
            title: 'O1 フロアランプの組み立てと接続方法',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_O1_JP_how.jpg?v=1751940305',
            products: ['O1']
        },
        "ND_NIxv9Cjc": {
            title: 'N1 ネオンロープライトの組み立てと接続方法',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_N1_JP_how.jpg?v=1751940305',
            products: ['N1']
        },
        "HP5AaNV0JDc": {
            title: 'E1 ストリングライトの組み立てと接続方法',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_E1_JP_how.jpg?v=1751940305',
            products: ['E1']
        },
        "65UUmW2Ut10": {
            title: 'Lepro OE1フロアランプの組み立て方法',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_OE1_JP_how_to_install.jpg?v=1759215144',
            products: ['OE1']
        },
        "Hk_eqCkrppE": {
            title: 'Lepro OE1 フロアランプの接続方法',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_OE1_JP_how_to_connect.jpg?v=1759215145',
            products: ['OE1']
        },
        "hLqw4WKPTI8": {
            title: '音声コントロールを有効にする手順 - Amazon Alexa',
            cover: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Alexa_JP_how.jpg?v=1752047773',
            products: []
        }
    }
}

window.LeProducts = [
    { name: 'Bulbs', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_Bulbs.png?v=1751943573' },
    { name: 'TB1', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_TB1.png?v=1751943573' },
    { name: 'TB2', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_TB2.png?v=1751943573' },
    { name: 'E1', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_E1.png?v=1751943573' },
    { name: 'N1', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_N1.png?v=1751943573' },
    { name: 'S1', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_S1.png?v=1751943572' },
    { name: 'ZB1', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_ZB1.png?v=1751943573' },
    { name: 'O1', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_O1.png?v=1751943573' },
    { name: 'T1', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_T1.png?v=1751943573' },
    { name: 'WL1', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_WL1.png?v=1751943573' },
    { name: 'R2', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_R2.png?v=1751943573' },
    { name: 'P1', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_P1.png?v=1751943573' },
    { name: 'M1', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_M1.png?v=1759135067' },
    { name: 'D1', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/D1.png?v=1787730056' },
    { name: 'F1/F2', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_F1.png?v=1759214558' },
    { name: 'OE1', product_img: 'https://cdn.shopify.com/s/files/1/0687/7980/2669/files/Youtube_Product_OE1.png?v=1759215144' }
]